module.exports = __webpack_public_path__ + "static/media/leaderboard.cfe6314f.svg";